import React from 'react';
import { useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { userGUIDSelector } from '@/domain/env';
import { matchRoute } from '@/domain/router/utils';
import router from '@/router/router';

// v7_startTransition stays off. On React 17 it does nothing; on React 18 it turns route updates into
// transitions while store updates stay urgent, so pages render against a store that is ahead of the
// route — this application keeps route state in Redux and is not built for that. Explicitly false,
// not removed: an unset flag logs a deprecation warning. React Router 7 wraps every update in a
// transition up to 7.14; from 7.15 the same opt-out is `<RouterProvider useTransitions={false} />`.

const RootRoute = () => {
  // reconsider approach based on other data set on auth event specifically
  // to indicate user has been loaded
  const userLoaded = useSelector(userGUIDSelector);

  return userLoaded || matchRoute.canBeAccessedUnauthorizedRoute() ? (
    <RouterProvider router={router} future={{ v7_startTransition: false }} />
  ) : null;
};

export default RootRoute;
